import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// components
import Layout from "layout/index";
import { Grid, Container, Typography, Box, Stack } from "@mui/material";
import { BottomButtons, OrderCard } from "components/unitComponent";

// translations

import { useTranslation } from "react-i18next";

import useCart from "../store";

// ----------------------------------------------------------------------

export default function Order() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const location = useLocation();

  const { language,cart, total, callCart, removeCart } = useCart((state) => state);

  useEffect(() => {
    callCart();
  }, []);

  const gap = "56px";

  return (
    <Layout>
      <Container
        sx={{
          px: "0 !important",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          "&:-webkit-scrollbar": { display: "none !important" },
        }}
      >
         
        <Box
          sx={{
            pt:4.5,
            px:7,
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflow: "scroll",
            "&:-webkit-scrollbar": { display: "none" },
          }}
        >
            <Typography variant="h2">
              {t("cart")}
            </Typography>
          <Box sx={{ "&:-webkit-scrollbar": { display: "none" } }}>
            {/* content=============================== */}
            <Box
              sx={{
                mr: 3,
                flexGrow: 1,
                mt: 5,
                "&:-webkit-scrollbar": { display: "none" },
              }}
            >
              <>
                <Stack gap={'20px'} sx={{ "&:-webkit-scrollbar": { display: "none" } }}>
                  {cart.map((item, i) => (
                    <OrderCard
                    language={language}
                      key={i}
                      t={t}
                      item={item}
                      removeItem={(item) => removeCart(item)}
                    />
                  ))}
                </Stack>
              </>
            </Box>
          </Box>
        </Box>

        {/* bottom =============================================== */}
        <Box>
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ bgcolor: "grey.soft", p: 3 }}
          >
            <Typography variant="h3">
              {t("total-pay")}
              {/* 총 결제금액 */}
            </Typography>
            <Typography  variant="h3" color="primary.main">
              {`${t('price', {price:Number(total).toLocaleString()})}`}
            </Typography>
          </Stack>
          <BottomButtons
            left={{
              label: t("prev"),
              onClick: () => {
                location?.state?.history ? navigate(-1) : navigate(-2);
              },
            }}
            right={{
              disabled: !total,
              label: t("next"),
              onClick: () => {
                navigate("/info");
              },
            }}
          />
        </Box>
      </Container>
    </Layout>
  );
}
